import useSWRFetcher from "../fetcher";
import useSWR from "swr";
import settings from "../../../../constants/settings";
import { CURRENCY, QuoteItem } from "../../../../reducers/uploadedBoard";

enum QuoteType {
  CUSTOM = "Custom",
  INSTANT = "Instant",
}

interface QuoteHistoryRecord {
  datetime_created: string;
  quote_type: QuoteType;
  lead_time_days: number | null;
  total: number;
  items: QuoteItem[];
  currency: CURRENCY;
}

interface QuoteHistoryResponse {
  quotes: QuoteHistoryRecord[];
}

export default function useQuoteHistory(boardId: string) {
  const fetcher = useSWRFetcher<QuoteHistoryResponse>(undefined);

  const { data, mutate } = useSWR<QuoteHistoryResponse>(
    `${settings.api_url}/boards/${boardId}/quote-history`,
    fetcher,
  );

  return {
    quoteHistory: data || null,
    refreshQuoteHistory: () => void mutate(),
  };
}
